// Lane 1400 WS1: the server's "I couldn't read <file>" notice arrives once,
// before any answer text. Later progress updates (stage, sources, reconnect)
// rebuild the progress state, so they must carry the notice forward or the
// buyer loses it while the answer is prepared (Codex code r1 #5).
export function keepNotice(prev, next) {
  return prev && prev.notice ? { ...next, notice: prev.notice } : next;
}
